export const ReportActionTypes = {
    GET_USER_REPORT: 'GET_USER_REPORT',
    GET_USER_DETAIL: 'GET_USER_DETAIL',
    GET_USER_FIREARMS: 'GET_USER_FIREARMS',
    GET_USER_INSURANCES: 'GET_USER_INSURANCES',
    GET_USER_INSPECTIONS: 'GET_USER_INSPECTIONS',
    GET_USER_SAFE_STORAGES: 'GET_USER_SAFE_STORAGES',
    GET_USER_ACCESSORIES: 'GET_USER_ACCESSORIES',
    GET_USER_AMMUNITIONS: 'GET_USER_AMMUNITIONS',
    GET_USER_INVOICES: 'GET_USER_INVOICES',
    GET_USER_PARTS: 'GET_USER_PARTS',
    GET_USERS: 'GET_USERS',
    SET_USER_QUERIES: 'SET_USER_QUERIES',
    SET_USER_LOADING: 'SET_USER_LOADING',
}
